module.exports = __webpack_public_path__ + "img/lunbo62.1812c86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo62.png
// module id = DtW5
// module chunks = 0